import { c as _c } from "react/compiler-runtime";
import { SnapshotShareDialog } from "@pages/project-details/project-snapshots/snapshot-share-dialog";
import { useState } from "react";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { MenuItem, ShareLinkIcon } from "@flat-ui";
import { SnapshotEvents } from "@utils/track-event/track-event-list";

/** Menu item component for sharing a snapshot, used in the snapshot options menu */
export function SnapshotShareMenuItem(t0) {
  const $ = _c(9);
  const {
    snapshot
  } = t0;
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const {
    trackEvent
  } = useTrackEvent();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsDialogOpen(false);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== snapshot.accessLevel || $[2] !== snapshot.id || $[3] !== trackEvent) {
    t2 = <MenuItem label="Share" Icon={ShareLinkIcon} onClick={() => {
      trackEvent({
        name: SnapshotEvents.openShareSnapshot,
        props: {
          snapshotId: snapshot.id,
          accessLevel: snapshot.accessLevel,
          location: "snapshot-mobile-menu-options"
        }
      });
      setIsDialogOpen(true);
    }} />;
    $[1] = snapshot.accessLevel;
    $[2] = snapshot.id;
    $[3] = trackEvent;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== isDialogOpen || $[6] !== snapshot || $[7] !== t2) {
    t3 = <SnapshotShareDialog snapshot={snapshot} isOpen={isDialogOpen} onClose={t1} location="snapshot-mobile-menu-options">{t2}</SnapshotShareDialog>;
    $[5] = isDialogOpen;
    $[6] = snapshot;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}